module.exports = require('./ui/overlays/upload-rom.template');